<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <v-icon :color="buttonColor">mdi-cog</v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item v-for="(item, index) in options" :key="index" @click="$emit('chosen', item.method)">
                <v-list-item-icon v-if="item.icon">
                    <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
/**
 * Wrapper for settings-button/select
 * <settings-button :options="settingsOptions" v-on:chosen="handleSettingsChoice"></settings-button>
 *
 * options =[{title: , method: }, ...]
 */
export default {
  name: 'SettingsButton',

  props: {
    options: Array,
    buttonColor: {
      type: String,
      default: 'grey lighten-1'
    }
  },

  methods: {
  }
};
</script>

<style scoped>

</style>